import React, { FC, ReactNode, useRef, useState } from 'react';

import classNames from 'classnames';

import './index.scss';

type Placement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

interface TooltipProps {
  title: ReactNode;
  placement?: Placement;
  isCloseClick?: boolean;
  disabled?: boolean;
}

const Tooltip: FC<TooltipProps> = (props) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { title, placement = 'top', children, isCloseClick, disabled } = props;

  document.addEventListener('click', (e: any) => {
    if (open && !e.path?.filter((p: any) => p === ref.current).length) {
      setOpen(false);
      e.stopPropagation();
    }
  });

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child as React.ReactElement<any>, {
        ref,
        onClick: () => !disabled && isCloseClick && setOpen(!open),
        onMouseMove: () => !disabled && !isCloseClick && setOpen(true),
        onMouseLeave: () => !disabled && !isCloseClick && setOpen(false),
        className: `tooltip-container ${child.props.className || ''} ${
          disabled ? 'tooltip-disabled' : ''
        }`,
        children: (
          <>
            {child.props.children}
            {open && (
              <div
                className={classNames('tooltip-root', {
                  [`tooltip-placement-${placement}`]: placement,
                })}
              >
                {title}
                {isCloseClick && (
                  <div
                    className="close"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(false);
                    }}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 6L6 18"
                        stroke="#2555FE"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6 6L18 18"
                        stroke="#2555FE"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                )}
              </div>
            )}
          </>
        ),
      });
    }
    return child;
  });

  return <>{childrenWithProps}</>;
};

export default Tooltip;
